import React from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';
import { Info } from 'lucide-react';
import { num, pct } from '../logistics/format';
import { DataTable } from './DataTable';
import { Insufficient } from '../logistics/format';

const lift = (v) => `${String(v.toFixed(1)).replace('.', ',')}×`;

const COLS = [
  { key: 'a', label: 'Produto A', wrap: true },
  { key: 'b', label: 'Produto B', wrap: true },
  { key: 'pedidos_juntos', label: 'Pedidos juntos', num: true, fmt: num },
  { key: 'pct_a_leva_b', label: 'Quem compra A leva B', num: true, fmt: pct },
  {
    key: 'lift', label: 'Lift', num: true, csv: (r) => r.lift,
    render: (r) => (
      <TooltipProvider><Tooltip><TooltipTrigger asChild>
        <span className="inline-flex items-center gap-1 cursor-help" data-testid="pair-lift">{lift(r.lift)}<Info className="h-3 w-3 text-muted-foreground" /></span>
      </TooltipTrigger><TooltipContent>Comprados juntos {lift(r.lift)} mais do que o esperado</TooltipContent></Tooltip></TooltipProvider>
    ),
  },
  { key: 'uso', label: 'Sugestão', sort: false, render: (r) => (r.lift >= 1.5 ? <span className="text-xs">Bom candidato a kit ou vitrine “compre junto”</span> : <span className="text-xs text-muted-foreground">Combinação comum</span>), csv: (r) => (r.lift >= 1.5 ? 'Bom candidato a kit ou vitrine compre junto' : '') },
];

export const PairsSection = ({ pairs, isPortal }) => (pairs.rows.length ? (
  <DataTable columns={COLS} rows={pairs.rows} testId="pairs-table" csvName={isPortal ? null : 'comprados-juntos.csv'} />
) : (
  <Insufficient message={`Nenhum par de produtos foi comprado junto em ${pairs.min_orders} pedidos ou mais neste período.`} testId="pairs-empty" />
));
